import { memo } from "react";
import { useLoadUserList } from "../../../../../hooks/useLoadUserList";
import { useOnMount } from "../../../../../hooks/useOnMount";
import { CircularProgress } from "@mui/material";
import { Colors } from "../../../../../utils/colors";
import FlatList from "flatlist-react/lib";
import { HorizontalDivider } from "../../../../Dividers/HorizontalDivider";
import {
  AccountData,
  SavedFormQuestion,
  SavedFormResponse,
} from "@markit/common.types";
import SavedResponseProfileItem from "../../../../DisplayItem/DataQuestion/SavedResponseProfileItem";

type SelectRecipientsDataItemResponsesProps = {
  responseUserIds: string[];
  setProfileSelected: (profileSelected: AccountData) => void;
  excludingMode: boolean;
  unsavedRecipients: string[];
  setUnsavedRecipients: (unsavedRecipients: string[]) => void;
  savedQuestion: SavedFormQuestion;
  formResponses: Map<string, SavedFormResponse>;
  selectable?: boolean;
};

export const SelectRecipientsDataItemResponses = memo(
  function SelectRecipientsDataItemResponsesFn(
    props: SelectRecipientsDataItemResponsesProps
  ) {
    const {
      responseUserIds,
      setProfileSelected,
      unsavedRecipients,
      excludingMode,
      setUnsavedRecipients,
      savedQuestion,
      formResponses,
      selectable = true,
    } = props;

    const { isFinished, isLoading, fetchedUserData, loadMoreUsers } =
      useLoadUserList({
        userIdList: responseUserIds,
        windowSize: 30,
      });

    useOnMount(() => {
      loadMoreUsers();
    });

    return (
      <div className="ColumnNormal">
        <FlatList
          list={fetchedUserData}
          renderWhenEmpty={() => <></>}
          renderItem={(item) => {
            const lastItem =
              fetchedUserData[fetchedUserData.length - 1].uid === item.uid;
            const formResponse = formResponses.get(item.uid);
            return (
              <div className="ColumnNormal" style={{ gap: 10 }}>
                <SavedResponseProfileItem
                  user={item}
                  subtext={
                    formResponse?.responses ? (
                      <span className="smallBodySubtext">
                        {formResponse.responses.join(", ")}
                      </span>
                    ) : undefined
                  }
                  savedQuestion={savedQuestion}
                  formResponse={formResponse}
                  setProfileSelected={setProfileSelected}
                  unsavedRecipients={unsavedRecipients}
                  setUnsavedRecipients={setUnsavedRecipients}
                  excludingMode={excludingMode}
                  disableCheck={!selectable}
                  removeDivider={lastItem && !isFinished}
                />
                {lastItem && !isFinished ? (
                  <div
                    className="ColumnNormal"
                    style={{ gap: 10, paddingBottom: 14 }}
                  >
                    <span
                      onClick={loadMoreUsers}
                      className="bodySubtext"
                      style={{ cursor: "pointer" }}
                    >
                      Load More...
                    </span>
                    <HorizontalDivider />
                  </div>
                ) : null}
              </div>
            );
          }}
          paginationLoadingIndicator={
            isLoading && !isFinished ? (
              <CircularProgress
                size={18}
                style={{ color: Colors.BLACK, paddingBlock: 14 }}
              />
            ) : null
          }
        />
      </div>
    );
  }
);
